import React, { useEffect, useState } from 'react';

import Header from "../componentes/Header";
import Footer from '../componentes/Footer';
import Seccion from "../componentes/Seccion";
import {Row, Col} from 'react-bootstrap'


function Empresa() {


  return (
    <div>
      <Header></Header>
      <Seccion theme='white' epicBarDirection="right" id="business_about">
        <Row >
                <Col md={12} lg={6}>
                        <div className="line">
                              <div>
                                <h2 className="titleStart title mrg-bt-10 txt-uppercase line-height-title letter-spacing-3px l:-mrg-right-60 fw-black fs-60">
                                  BENEFITS <br/> 
                                  <span className="fw-light">
                                    OF <br/> 
                                    DICIO
                                  </span>
                                </h2>
                              </div>
                              <br></br>
                              <div>
                                <ul className="--check">
                                  <li>
                                    Deterministic Unique Number, Correlates and Masks
                                  </li>
                                  <li>
                                    Advanced Cryptographic Key Based on Vectorized Face
                                  </li>
                                  <li>
                                    DNA Genome Profile of Personal Data
                                  </li>
                                  <li>
                                    Advanced Video Token
                                  </li>
                                  <li>
                                    Attestation and Consent in Blockchain with Face Keys
                                  </li>
                                  <li>
                                    Wallet with Universal Points
                                  </li>
                                </ul>
                              </div>
                            </div>
                </Col>
                <Col md={12} lg={6} style={{paddingTop:"50px"}}>
                        <div className="aspect-ratio-16:9">
                              <iframe 
                              width="727" 
                              height="409" 
                              src="https://www.youtube.com/embed/1RV9ZnpLeus" 
                              frameborder="0" 
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                              allowfullscreen
                              className="w-100 aspect-ratio-item"
                              >
                              </iframe>
                            </div>

                </Col>
              </Row>
      </Seccion>
      <Seccion theme='dark' id="business_success_stories">
        <Row className="successCont" style={{paddingLeft:"80px"}}>
              <div className="success-cont" style={{paddingLeft:"50px"}}>
                <Row>
                  <Col lg={12}>
                    <div className="center mrg-bottom-60 mrgBottom">
                          <h2 className="title mrg-bt-10 line-height-title letter-spacing-3px mrg-right-60 c-white fw-black fs-60 successTitle">
                            SUCCESS STORIES
                          </h2>
                        </div>
                  </Col>
                </Row>

                <Row>
                  <Col lg={6} style={{paddingBottom:"50px"}}>
                    <div className="c-white">
                      <div className="succes-story pad-all-40 --dark twins" style={{height: "427px"}}>
                        <Row className="line ">
                          <Col xl={3} lg={12} sm={3} className="center">
                            <img src="./img/casos-exito-uno.svg" style={{maxWidth: "192px", width: "100%"}}/>
                          </Col>
                          
                          <Col xl={9} lg={12} sm={9} className="top">
                            <div className="line">
                              <div className="">
                                <p className="fs-24 fw-bold">
                                  CRYPTO FACE KEY
                                </p>
                              </div>

                              <div className="">
                                <p className="line-height-text">
                                  Through a facekey validation, we obtain a unique encryption 
                                  mechanism for personal information.
                                </p>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>

                  <Col lg={6}>
                    <div className="c-white">
                      <div className="succes-story pad-all-40 --dark twins" style={{minHeight: "427px"}}>  
                        <Row className="line ">
                          <Col xl={3} lg={12} sm={3} className="top center">
                            <img src="./img/casos-exito-dos.svg" style={{maxWidth: "192px", width: "100%"}}/>
                          </Col>
                          
                          <Col xl={9} lg={12} sm={9} className="top">
                            <div className="line">
                              <div className="">
                                <p className="fs-24 fw-bold">
                                  ATTESTATIONS AND BLOCKCHAIN VALIDATION
                                </p>
                              </div>
                              
                              <div className="">
                                <p className="line-height-text">
                                  We maintain a traceable and auditable system in a reliable way, 
                                  using a trusted network such as blockchain, which will keep the 
                                  traceability of our operation permanently, clean and incorruptible by third parties.
                                </p>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div> 
                  </Col>
                </Row>
              </div>
            </Row>
      </Seccion>
      <Footer></Footer>
    </div>
  );
}

export default Empresa